import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './Login.css';

const Login = () => {
  const { login } = useAuth();

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Interscale AutoHub</h1>
          <p>Sign in with your Microsoft account</p>
        </div>
        
        <div className="login-body">
          <button className="login-button" onClick={login}>
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
              <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
              <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
              <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
            </svg>
            Sign in with Microsoft
          </button>
        </div>

        <div className="login-footer">
          <p className="text-sm text-gray-500">
            Secure authentication powered by Azure AD
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
